const DIFF = 'diff';
const SLIDER = 'slider';
const FADE = 'fade';

export const COMPARE_METHODS = {DIFF, SLIDER, FADE} as const;

export const COMPARE_TYPES = {
  RESULT: 'result',
  MOSAIC: 'basemap',
  SCENE: 'item',
  VISUAL_ANALYSIS: 'visualAnalysis',
} as const;
